(function () {
    "use strict";

    angular
        .module("app")
        .directive("patternDescriptionSearchHelp", ["SearchFactory", patternDescriptionSearchHelp]);

    function patternDescriptionSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.patternDescription = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.patternDescription === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.patternDescriptionSearch(function (patternDescription) {
                        scope.patternDescription = patternDescription ? patternDescription.Description : "";
                        scope.displayValue = scope.patternDescription;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.displayValue = scope.patternDescription;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("patternDescription", function (newValue) {
                    scope.displayValue = newValue;
                    if (newValue == null) {
                        scope.prevDisplayValue = null;
                    }
                });
            },
            scope: { patternDescriptionKey: "=", patternDescription: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

